export const APP_STARTED = 'APP_STARTED';
export const APP_CONTEXT_SET = 'APP_CONTEXT_SET';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const INITIALIZE_ADMIN_AUTH = 'INITIALIZE_ADMIN_AUTH';
export const PORTAL_SCOPES_REQUESTED = 'PORTAL_SCOPES_REQUESTED';
export const PORTAL_SCOPES_RECEIVED = 'PORTAL_SCOPES_RECEIVED';
export const PORTAL_SCOPES_FAILED = 'PORTAL_SCOPES_FAILED';
export const ACADEMY_CERTIFICATIONS_REQUESTED = 'ACADEMY_CERTIFICATIONS_REQUESTED';
export const ACADEMY_CERTIFICATIONS_RECEIVED = 'ACADEMY_CERTIFICATIONS_RECEIVED';
export const ACADEMY_CERTIFICATIONS_FAILED = 'ACADEMY_CERTIFICATIONS_FAILED';
export const STOREFRONT_SEARCH_TAGS_REQUESTED = 'STOREFRONT_SEARCH_TAGS_REQUESTED';
export const STOREFRONT_SEARCH_TAGS_RECEIVED = 'STOREFRONT_SEARCH_TAGS_RECEIVED';
export const STOREFRONT_SEARCH_TAGS_FAILED = 'STOREFRONT_SEARCH_TAGS_FAILED';
export const REVIEW_WRITE_REQUESTED = 'REVIEW_WRITE_REQUESTED';
export const REVIEW_WRITE_RECEIVED = 'REVIEW_WRITE_RECEIVED';
export const REVIEW_WRITE_FAILED = 'REVIEW_WRITE_FAILED';
export const STOREFRONT_UNUSED_FILTERS_REQUESTED = 'STOREFRONT_UNUSED_FILTERS_REQUESTED';
export const STOREFRONT_UNUSED_FILTERS_RECEIVED = 'STOREFRONT_UNUSED_FILTERS_RECEIVED';
export const STOREFRONT_UNUSED_FILTERS_FAILED = 'STOREFRONT_UNUSED_FILTERS_FAILED';
export const REVIEWABILITY_REQUESTED = 'REVIEWABILITY_REQUESTED';
export const REVIEWABILITY_RECEIVED = 'REVIEWABILITY_RECEIVED';
export const REVIEWABILITY_FAILED = 'REVIEWABILITY_FAILED';
export const REVIEWABILITY_RESET = 'REVIEWABILITY_RESET';
export const REVIEWS_LIST_REQUESTED = 'REVIEWS_LIST_REQUESTED';
export const REVIEWS_LIST_RECEIVED = 'REVIEWS_LIST_RECEIVED';
export const REVIEWS_LIST_FAILED = 'REVIEWS_LIST_FAILED';
export const REVIEWS_LIST_RESET = 'REVIEWS_LIST_RESET';
export const REVIEW_STATS_REQUESTED = 'REVIEW_STATS_REQUESTED';
export const REVIEW_STATS_RECEIVED = 'REVIEW_STATS_RECEIVED';
export const REVIEW_STATS_FAILED = 'REVIEW_STATS_FAILED';
export const REVIEW_STATS_RESET = 'REVIEW_STATS_RESET';
export const REVIEW_FILTERS_INITIALIZED = 'REVIEW_FILTERS_INITIALIZED';
export const REVIEW_FILTERS_UPDATED = 'REVIEW_FILTERS_UPDATED';
export const REVIEW_HELPFUL_REQUESTED = 'REVIEW_HELPFUL_REQUESTED';
export const REVIEW_HELPFUL_RECEIVED = 'REVIEW_HELPFUL_RECEIVED';
export const REVIEW_HELPFUL_FAILED = 'REVIEW_HELPFUL_FAILED';
export const REVIEW_REPORT_REQUESTED = 'REVIEW_REPORT_REQUESTED';
export const REVIEW_REPORT_RECEIVED = 'REVIEW_REPORT_RECEIVED';
export const REVIEW_REPORT_FAILED = 'REVIEW_REPORT_FAILED';
export const REVIEW_REPLY_REPORT_REQUESTED = 'REVIEW_REPLY_REPORT_REQUESTED';
export const REVIEW_REPLY_REPORT_RECEIVED = 'REVIEW_REPLY_REPORT_RECEIVED';
export const REVIEW_REPLY_REPORT_FAILED = 'REVIEW_REPLY_REPORT_FAILED';